/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_No_MatchesInputs */

const en_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches found`)
};

const ar_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد نتائج`)
};

const bn_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনো ফলাফল মেলেনি`)
};

const de_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Treffer gefunden`)
};

const es_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const fr_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat`)
};

const pt_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado`)
};

const zh_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到匹配项`)
};

const tr_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eşleşme bulunamadı`)
};

const ru_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совпадений не найдено`)
};

const pl_nav_no_matches = /** @type {(inputs: Nav_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono żadnych dopasowań`)
};

/**
* | output |
* | --- |
* | "No matches found" |
*
* @param {Nav_No_MatchesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_no_matches = /** @type {((inputs?: Nav_No_MatchesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_No_MatchesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_no_matches(inputs)
	if (locale === "bn") return bn_nav_no_matches(inputs)
	if (locale === "de") return de_nav_no_matches(inputs)
	if (locale === "es") return es_nav_no_matches(inputs)
	if (locale === "fr") return fr_nav_no_matches(inputs)
	if (locale === "pt") return pt_nav_no_matches(inputs)
	if (locale === "zh") return zh_nav_no_matches(inputs)
	if (locale === "tr") return tr_nav_no_matches(inputs)
	if (locale === "ru") return ru_nav_no_matches(inputs)
	if (locale === "pl") return pl_nav_no_matches(inputs)
	return en_nav_no_matches(inputs)
});